import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import ColorTemperatureDialog1 from "../twin-widget-dialog/color-temperature-dialog-1";
import { SyncBadge } from "../../common/badges";

const ColorTemperature1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [colorTemp, setColorTemp] = useState(2700);
  const [tempMinMax, setTempMinMax] = useState({ min: 2700, max: 6500 });

  useEffect(() => {
    if (widget) {
      setTempMinMax({
        min: widget.min ?? 2700,
        max: widget.max ?? 6500,
      });
      setColorTemp(
        widget.items.$w1.value ? parseInt(widget.items.$w1.value) : 2700
      );
    }
  }, [widget]);

  const handleTempChange = (event, newValue) => {
    event.stopPropagation();
    const adjustedValue = Math.min(
      Math.max(newValue, tempMinMax.min),
      tempMinMax.max
    );
    setColorTemp(adjustedValue);
    const updatedWidget = {
      ...widget.items.$w1,
      value: adjustedValue.toString(),
    };
    onValueUpdate(updatedWidget);
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: "fit-content",
        overflow: "hidden",
      }}
    >
      {pattern && pattern.endsWith("_W") && <SyncBadge />}
      <ColorTemperatureDialog1
        colorTemp={colorTemp}
        onColorTempChange={handleTempChange}
        minTemp={tempMinMax.min}
        maxTemp={tempMinMax.max}
        disabled={pattern && pattern.endsWith("_R")}
      />
    </Box>
  );
};

export default ColorTemperature1Widget;
